// import { getProp } from '@src/helpers';
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import useZustandStore from "@src/helpers/zustand";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { LoggerTypes, useKYCAddUserLog } from "@src/api/useKYCAddUserLog";
// import { parseISO } from 'date-fns';

interface DataType {
  apiKey: string;
  sessionId: string;
  contextId: string;
}

export interface IdontomatData {
  firstName: string;
  lastName: string;
  birthDate: string; // ISO 8601 formatted date
  expirationDate: string; // ISO 8601 formatted date
  sex: string;
  nationality: string;
  issueDate: string; // Could be ISO 8601 or another string format
  issueDateTime: string; // ISO 8601 formatted date
  authority: string;
  documentNumber: string;
  personalNumber: string;
  documentFrontSide: string; // Base64 or URL
  documentBackSide: string; // Base64 or URL
  documetType: string; // Correct spelling to 'documentType' if typo
  selfImage?: string; // Base64 or URL
  selfImages: {
    imageName: string;
    imagePath: string;
    imageID: number;
  }[];
  verified: boolean;
  status: string;
  countryID: number;
  countryName: string;
  birthPlace: string;
  localFirstName: string;
  localLastName: string;
  legalAddress: string;
  legalCity: string;
  birthCountryId: number;
  legalCountryID: number;
  faceImage: string; // Base64 or URL
  citizenship: string;
}

const apiCall = async ({ apiKey, sessionId, contextId }: DataType) => {
  const response = await axiosInstance.post<IdontomatData>(
    "/api/kyc/session/close",
    { sessionId, contextId },
    {
      headers: {
        "x-options": "DateFormatISO",
        "x-api-key": apiKey,
      },
    }
  );
  const [frontSide, backSide] = await Promise.all([
    response.data.documentFrontSide
      ? axios.get<Blob>(response.data.documentFrontSide, {
          responseType: "blob",
          headers: {
            Authorization: apiKey,
          },
        })
      : null,
    response.data.documentBackSide
      ? axios.get<Blob>(response.data.documentBackSide, {
          responseType: "blob",
          headers: {
            Authorization: apiKey,
          },
        })
      : null,
  ]);

  return {
    ...response.data,
    documentFrontSideBlob: frontSide ? URL.createObjectURL(frontSide.data) : "",
    documentBackSideBlob: backSide ? URL.createObjectURL(backSide.data) : "",
  };
};

export const useCloseSession = () => {
  const addUserLogMutation = useKYCAddUserLog();
  const navigate = useNavigate();
  const { data: zData, setData } = useZustandStore((state) => state);
  const { i18n } = useTranslation();
  return useMutation(apiCall, {
    onSuccess(data) {
      addUserLogMutation.mutate({
        eventName: LoggerTypes.IdentomatSuccess,
      });
      navigate(`/${i18n.language}/review-details`);
      setData({
        ...zData,
        closeSession: data,
        citizenship: {
          ...zData.citizenship,
          birthCity: data.birthPlace,
          birthCountry: data.birthCountryId,
          passportCountry: data.legalCountryID || data.countryID,
          // birthCountry: number;
          // passportCountry: number;
          // birthCity: string;
          // otherCountry: number;
          // nonCitizen: boolean;
        },
        address: {
          ...zData.address,
          legalAddress: data.legalAddress,
          legalCity: data.legalCity,
          legalCountry: data.legalCountryID || data.countryID,
          // legalCountry: number;
          // legalCity: string;
          // legalAddress: string;
          // check: boolean;
          // factCountryID: number;
          // factCity: string;
          // factAddress: string;
        },
      });
    },
    onError({ response, error }: any) {
      setData({
        ...zData,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- we trust the api
        errorMessage: response.data.displayText || response.data.DisplayText,
      });
      navigate(`/${i18n.language}/error`);
    },
  });
};
